(ns ycweb.app.blitz.aftersales.queryitem
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(def steps
  (forms/setup-steps
    [{:key :query-item :title "Scan Item"}
     {:key :details :title "Item Details"}
     {:key :destination :title "Change Destination"}
     {:key :done :title "Done"}]))

(rum/defc item-query-done < rum/reactive
  [app-atom]
  (w/wrapper app-atom "Query Item" {:steps steps :step :done}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:flush :large])}
        [:b "The Destination has been updated."]]]]]
    []
    [[:p.u-text-center
      {:class (u/bem :paragraph [:flush :large])}
      [:a.text-link {:on-click #(t/transition-next app-atom :main-menu)} "Done for now"]]
     (grid/pos-call-to-action
       {:single-text "Query Another Item"
        :single-fn #(t/transition-next app-atom :aftersales/item-query)})]))

(defmethod flow/render-screen :aftersales/item-query-done [app-atom screen]
  (item-query-done app-atom))

(defmethod comms/receive :aftersales/item-query-destination [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :aftersales/item-query-done))

(defmethod grid/action :aftersales/item-query-destination [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [barcode newdestination]} (get-in @app-atom [:aftersales :item-query :details])]
    (comms/send :aftersales/item-query-destination
      {:barcode barcode
       :destination newdestination})))

(rum/defc item-query-destination < rum/reactive [app-atom]
  (let [{:keys [destinations details]} (cmn/curact app-atom [:aftersales :item-query])]
    (w/wrapper app-atom "Query Item" {:steps steps :step :destination}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Change Destination"
         [:span.heading__subtext
          "from " (:destination details) " to..."]]
        [:form.u-margin-top-24
         (forms/select "Destination:" (rum/cursor-in app-atom [:aftersales :item-query :details :newdestination])
           (concat
             [{:text " - Please Select - " :value ""}]
             (map (fn [d] {:text d :value d}) destinations))
           {})]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(grid/dispatch-action app-atom :aftersales/item-query-destination {})
         :right-text "Update"}))))

(defmethod flow/render-screen :aftersales/item-query-destination [app-atom screen]
  (item-query-destination app-atom))

(rum/defc item-query-details < rum/reactive [app-atom]
  (let [{:keys [features brand refid dateadded product lname binname destination notes images barcode]}
        (cmn/curact app-atom [:aftersales :item-query :details])
        bincolour
        (case (last binname)
          \G :green
          \R :red
          \B :blue
          \Y :yellow
          \C :grey
          :black)]

    (w/wrapper app-atom "Query Item" {:steps steps :step :details}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Item in:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b lname " "]
         (when binname
           [:span {:class (u/bem :pill [:large :picking-bin bincolour])}
            binname])
         [:span.heading__subtext
          "Notes: " [:b notes]]]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__barcode
           "Destination: " [:b.u-barcode.u-block destination]]
          [:div.product-card__barcode
           "YCR: " [:b.u-barcode.u-block refid]]
          [:div.product-card__barcode
           "Date: " [:b.u-barcode.u-block dateadded]]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :aftersales/item-query-destination)
         :right-text "Destination"}))))

(defmethod flow/render-screen :aftersales/item-query-details [app-atom screen]
  (item-query-details app-atom))

(defmethod comms/receive :aftersales/query-item-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom
    #(->
       %
       (assoc-in [:aftersales :item-query :details] (:details e))
       (assoc-in [:aftersales :item-query :destinations] (:destinations e))))
  (t/transition-next app-atom :aftersales/item-query-details))

(defmethod grid/action :aftersales/query-item-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersales/query-item-scan {:scan scan}))

(defmethod flow/barcode-dispatch-screen :aftersales/item-query [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersales/query-item-scan {:scan scan}))

(defmethod grid/action :aftersales/item-query-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :aftersales/query-item-scan
     :input-key :scan
     :input-type :barcode}))

(defn item-query-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :aftersales/item-query-menu-barcode}

      {:label "Cancel"
       :action :aftersales/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc item-query < rum/reactive [app-atom]
  (w/wrapper app-atom "Query Item" {:modal-fn item-query-menu-modal :steps steps :step :query-item}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Item"]
      grid/barcode-icon]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Item"
       :right-plain true})))

(defmethod flow/render-screen :aftersales/item-query [app-atom screen]
  (item-query app-atom))